import React from 'react';

const PharmacySaleManagementPage = React.lazy(() => import('pages/PharmacySaleManagement/PharmacySaleManagementPage'));

const routes = [
  {
    path: '/pharmacy-sale-management',
    exact: true,
    name: 'Quản lý đơn thuốc bán',
    function: 'APP_PHARMACY_SALE_VIEW',
    component: PharmacySaleManagementPage,
  },
];

export default routes;
